<template>
  <div class="chartDom" ref="chartDom"></div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      msg: '饼图-半径模式',
      echartParams: this.data,
      timeId: null,
      myChart: null,
    }
  },
  created() {},
  mounted() {
    this.drawLineCustom(this.echartParams)
  },
  destroyed() {
    clearInterval(this.timeId)
  },
  methods: {
    drawLineCustom(params) {
      this.myChart = this.$echarts.init(this.$refs.chartDom)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          top: 10,
          left: 20,
          right: 10,
          bottom: 10,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: params.xdata,
            axisTick: { show: false },
            axisLine: {
              lineStyle: {
                color: '#A4BEE266',
              },
            },
            axisLabel: {
              color: '#3B4F6A',
              rotate: params.rotate && params.rotate,
              show: true, // 显示所有x轴标签
              interval: 0,
              rotate: 15,
            },
          },
        ],
        yAxis: [
          {
            nameTextStyle: {
              fontSize: 10,
            },
            type: 'value',
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#A4BEE266',
              },
            },
            axisLabel: {
              color: '#3B4F6A',
            },
            minInterval: 1, // Y 轴的最小间隔为 1
          },
        ],
        series: [
          {
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(255, 255, 255, 0.3)',
            },
            barWidth: 12,
            itemStyle: {
              borderRadius: [10, 10, 10, 10],
              color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#7FB7FD' },
                { offset: 1, color: '#5282E6' },
              ]),
            },
            data: params.ydata,
          },
        ],
      }

      this.myChart.setOption(option, true)
      window.addEventListener('resize', () => {
        if (this.myChart) {
          this.myChart.resize()
        }
      })
    },
  },

  watch: {
    data: {
      immediate: true,
      deep: true,
      handler: function (newValue, oldValue) {
        this.$nextTick(() => {
          clearInterval(this.timeId)
          this.drawLineCustom(newValue)
        })
      },
    },
  },
}
</script>

<style lang="less" scoped>
.chartDom {
  width: 100%;
  height: 100%;
}
</style>
